import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import { recallRoutes } from "../../../../router/routesConstants";

function RecallEntriesActionButton({ itemId }: { itemId: string | number }) {
  return (
    <ActionMenu
      minItemsForMenu={2}
      ariaLabel={`Actiuni pentru retragerea ${itemId}`}
      items={[
        {
          id: "details",
          label: "Detalii",
          icon: "DOCUMENTS",
          tooltip:
            "Deschide retragerea cu farmaciile identificate, documentele, AWB-urile, stocul si intrarile de la furnizori.",
          navigate: `/${recallRoutes.recall}/${itemId}`,
        },
      ]}
    />
  );
}

export default RecallEntriesActionButton;
